import React from 'react';
import { Drawer } from 'antd';
import MessageDetails from './MessageDetails/MessageDetails';
import { useTranslation } from 'react-i18next';

const MessageDetailsDrawer = ({
    screens,
    drawerVisible,
    selectedMessage,
    setDrawerVisible,
    setSelectedMessage,
    onDeleteMessage
}) => {
    const { t } = useTranslation();
    
    return (
    <Drawer
        title={t('message_details')}
        placement="right"
        width={screens.xs ? '100%' : 480}
        open={drawerVisible}
        onClose={() => {
            setDrawerVisible(false);
            setSelectedMessage(null);
        }}
    >
        <MessageDetails 
            message={selectedMessage} 
            onDeleteMessage={onDeleteMessage}
            onClose={() => {
                setDrawerVisible(false);
                setSelectedMessage(null);
            }}
        />
    </Drawer>
    );
};

export default MessageDetailsDrawer;
